var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthCareLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "health-care-love_svgrepo.com"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.52628 14.0985C6.35603 17.361 4.57178 21.7823 4.57178 26.3925C4.57178 31.005 6.35603 35.4263 9.52628 38.6865L31.1825 60.9593C32.4605 62.2733 34.1953 63.0068 36.0043 63.0068C37.811 63.0068 39.548 62.2733 40.826 60.9593C44.7478 56.925 62.4643 38.6685 62.4643 38.6685C65.6345 35.4083 67.4188 30.987 67.4188 26.3745C67.4188 21.762 65.6345 17.343 62.4643 14.0805C59.2715 10.7978 54.938 8.95728 50.4223 8.95728C45.9065 8.95728 41.5753 10.7978 38.3825 14.0805L35.9863 16.5443L33.608 14.0985C30.4153 10.8158 26.084 8.97528 21.5683 8.97528C17.0525 8.97528 12.719 10.8158 9.52628 14.0985ZM12.7528 17.2373C15.0905 14.832 18.2608 13.4753 21.5683 13.4753C24.8758 13.4753 28.0438 14.832 30.3815 17.2373L34.373 21.3413C34.796 21.7755 35.3788 22.023 35.9863 22.023C36.5938 22.023 37.1765 21.7755 37.5995 21.3413L41.609 17.217C43.9468 14.814 47.1148 13.4573 50.4223 13.4573C53.7298 13.4573 56.8978 14.814 59.2378 17.217C59.2445 17.226 59.2513 17.2328 59.2603 17.2418C61.598 19.647 62.9188 22.941 62.9188 26.3745C62.9188 29.808 61.598 33.1043 59.2378 35.532C59.2378 35.532 41.5213 53.7885 37.5995 57.8228C37.1765 58.257 36.6028 58.5068 36.0043 58.5068C35.4058 58.5068 34.832 58.257 34.409 57.8228L12.7528 35.55C10.3925 33.1223 9.07178 29.826 9.07178 26.3925C9.07178 22.959 10.3925 19.665 12.7528 17.2373Z",
    fill: "#FDB813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7457 33.7568H29.2524C28.0104 33.7568 27.0024 34.7648 27.0024 36.0068C27.0024 37.2488 28.0104 38.2568 29.2524 38.2568H33.7457V42.75C33.7457 43.992 34.7537 45 35.9957 45C37.2377 45 38.2457 43.992 38.2457 42.75V38.2568H42.7389C43.9809 38.2568 44.9889 37.2488 44.9889 36.0068C44.9889 34.7648 43.9809 33.7568 42.7389 33.7568H38.2457V29.2635C38.2457 28.0215 37.2377 27.0135 35.9957 27.0135C34.7537 27.0135 33.7457 28.0215 33.7457 29.2635V33.7568Z",
    fill: "#33336F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthCareLove);
export default __webpack_public_path__ + "static/media/health-care-love.afe56239892566418c02b1c1a71d0e89.svg";
export { ForwardRef as ReactComponent };